import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-search-cost',
    templateUrl: './search-cost.component.html',
    standalone: false
})
export class SearchCostComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
